var t;(function(t){t["BUTTON"]="button";t["RESET"]="reset";t["SUBMIT"]="submit"})(t||(t={}));export{t as EButtonType};
//# sourceMappingURL=enums.js.map
